import { DialogCloseEvent, DialogComponent } from '@theme/dialog';

const COOKIE_MAX_AGE_DAYS = 30;

/**
 * Promotional dialog shown on load until dismissed; dismissal stored in a cookie.
 *
 * @extends {DialogComponent}
 */
class HeaderPopupComponent extends DialogComponent {
  /** @type {string} */
  #cookieName = '';

  connectedCallback() {
    super.connectedCallback();
    const cookieName = this.getAttribute('cookie-name') || 'header-popup-dismissed';
    this.#cookieName = cookieName;
    if (this.#hasCookie()) return;
    this.addEventListener(DialogCloseEvent.eventName, this.#persistDismiss);
    this.addEventListener('click', this.#onInnerLinkClick, true);
    requestAnimationFrame(() => {
      this.showDialog();
    });
  }

  disconnectedCallback() {
    this.removeEventListener(DialogCloseEvent.eventName, this.#persistDismiss);
    this.removeEventListener('click', this.#onInnerLinkClick, true);
    super.disconnectedCallback();
  }

  #hasCookie() {
    return document.cookie.split('; ').some((c) => c.startsWith(`${this.#cookieName}=`));
  }

  #persistDismiss = () => {
    const expires = new Date(Date.now() + COOKIE_MAX_AGE_DAYS * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${this.#cookieName}=1; expires=${expires}; path=/; SameSite=Lax`;
  };

  /**
   * CTA / in-content links: persist dismiss so the promo does not return after navigation.
   *
   * @param {MouseEvent} event
   */
  #onInnerLinkClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const anchor = event.target.closest('a[href]');
    const inner = this.querySelector('.header-popup__inner');
    if (!anchor || !inner?.contains(anchor)) return;
    const href = anchor.getAttribute('href');
    if (href == null || href === '' || href === '#') return;
    if (anchor.getAttribute('aria-disabled') === 'true') return;
    this.#persistDismiss();
  };
}

if (!customElements.get('header-popup')) {
  customElements.define('header-popup', HeaderPopupComponent);
}
